<div *ngIf="reportType == 'Advtoutstandingbriefly'">
  <div class="container" id="print-section">

    <table class="report-table">
      <thead>
        <tr>
          <th colspan="2" class="br-bottom br-right br-top" style="font-size: medium;">हिंदुस्तान प्रकाशन संस्था - विवेक
            साप्ताहिक</th>
          <th colspan="2" class="br-bottom br-right br-top small-text">Advt. Outstanding Report</th>
          <th colspan="3" class="br-bottom br-right br-top small-text">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th colspan="3" class="br-bottom br-right small-text">All Outstanding Briefly</th>
          <!-- <th colspan="1" class="br-bottom br-right small-text"></th> -->
          <th colspan="4" class="br-bottom small-text">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th class="br-bottom br-right small-text">Representative Name</th>
          <th class="br-bottom br-right small-text">Contact No</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Advt Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">GST Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Net Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Receive Amount</th>
          <th class="br-bottom br-right small-text" style="text-align: center;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data of OutstandingB">
          <!-- Office Representative Row -->
          <tr>
            <td colspan="7" class="br-bottom br-top bold-text off_rep_name">
              Office Representative Name :
              <span class="ft-wt-200" style="font-weight: bold;font-size: 17px;">{{data.off_rep_name}} /
                {{data.office_rep_mob}}</span>
            </td>
          </tr>

          <!-- Inner Representatives -->
          <tr *ngFor="let data1 of data.rep_data">
            <td class="br-right" style="font-size: 14px;font-weight: bold;">{{data1.rep_name}}</td>
            <td class="br-right">{{data1.rep_mob}}</td>
            <td class="br-right" style="font-weight:bold;text-align: right;">{{(data1.contract_bkng_advt_amt *
              1).toFixed(2)}}</td>
            <td class="br-right" style="font-weight:bold;text-align: right;">{{(data1.contract_gst_amt * 1).toFixed(2)}}
            </td>
            <td class="br-right" style="font-weight:bold;text-align: right;">{{(data1.contract_net_total *
              1).toFixed(2)}}</td>
            <td class="br-right" style="font-weight:bold;text-align: right;">{{(data1.contract_rcv_total *
              1).toFixed(2)}}</td>
            <td style="font-weight:bold; text-align: right;">
              {{ (data1.contract_bal_amt * 1) === 0
              ? ''
              : (data1.contract_bal_amt * 1).toFixed(2) }}
            </td>
          </tr>
          <!-- Total per Office Rep -->
          <tr>
            <td colspan="2" class="br-bottom br-top br-right bold-text" style="font-weight: bold;">Total:
              {{data.off_rep_name}}</td>
            <td class="br-bottom br-top br-right" style="font-weight: bold; text-align: right;font-size: 17px;">
              {{(data.adv_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top br-right" style="font-weight: bold; text-align: right;font-size: 17px;">
              {{(data.gst_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top br-right" style="font-weight: bold; text-align: right;font-size: 17px;">
              {{(data.net_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top br-right" style="font-weight: bold; text-align: right;font-size: 17px;">
              {{(data.rcv_total * 1).toFixed(2)}}</td>
            <td class="br-bottom br-top" style="font-weight: bold; text-align: right; font-size: 17px;">
              {{ (data.bal_total * 1) === 0
              ? ''
              : (data.bal_total * 1).toFixed(2) }}
            </td>

          </tr>
        </ng-container>
      </tbody>

      <!-- Grand Total -->
      <tr>
        <td colspan="2" class="br-bottom br-top br-right bold-text">Total: Rs</td>
        <td class="br-bottom br-top br-right bold-text" style="font-weight: bold; text-align: right;font-size: 18px;">
          {{(totalAdvtAmount * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top br-right bold-text" style="font-weight: bold; text-align: right;font-size: 18px;">
          {{(totalGstAmount * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top br-right bold-text" style="font-weight: bold; text-align: right;font-size: 18px;">
          {{(totalNetAmount * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top br-right bold-text" style="font-weight: bold; text-align: right;font-size: 18px;">
          {{(totalRcvAmount * 1).toFixed(2)}}</td>
        <td class="br-bottom br-top bold-text" style="font-weight: bold; text-align: right;font-size: 18px;">
          {{(totalUnpaidAmount * 1).toFixed(2)}}</td>
      </tr>
    </table>

    <!-- Footer & Buttons -->
    <div class="footer-line"></div>


  </div>

  <div class="actions noPrint">
    <button mat-raised-button color="primary" (click)="exportExcel('Contract_Brief_Report')">Export</button>

    <button mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>